import React from 'react';
import PropTypes from 'prop-types';
import { emptyString } from 'constants/emptyConst';
import { withTranslation } from 'react-i18next';
import { Button, Dialog } from '@totalsoft/rocket-ui';
import { BoxActionsWrapper } from 'components/common/CommonStyles';

const OfferPartnerVerificationSummaryModal = ({ closeVerificationSummaryModal, t, summary }) => {
  return (
    <Dialog
      open={true}
      aria-labelledby='externalSearch-dialog-title'
      maxWidth='lg'
      fullWidth
      disableEscapeKeyDown
      onClose={closeVerificationSummaryModal}
      title={t('Summary')}
      content={<div dangerouslySetInnerHTML={{ __html: summary }} />}
      actions={
        <BoxActionsWrapper forDialog>
          <Button id={'offerPartnerVerification_summaryModal_close'} onClick={closeVerificationSummaryModal} fullWidth>
            {t('Close')}
          </Button>
        </BoxActionsWrapper>
      }
    />
  );
};

OfferPartnerVerificationSummaryModal.propTypes = {
  closeVerificationSummaryModal: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  summary: PropTypes.string.isRequired
};

OfferPartnerVerificationSummaryModal.defaultProps = {
  summary: emptyString
};

export default withTranslation()(OfferPartnerVerificationSummaryModal);
